import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/atas'

class AcompanhamentoAtaApiClient {
	async buscarPorFiltro(filters, pagingAndSorting, idAta) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${idAta}/acompanhamento`,
			filters,
			pagingAndSorting,
		}).build()
		return await axios.get(url)
	}
	async buscarListagemDeOrgaosPorItem(pagingAndSorting, idAta, idItemAta) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${idAta}/acompanhamento/item/${idItemAta}`,
			pagingAndSorting,
		}).build()
		return await axios.get(url)
	}

	async buscarListagemDetalhesSaldoPorOrgao(filters, pagingAndSorting, idAta, idItem) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${idAta}/acompanhamento/item/${idItem}/pedidos`,
			filters,
			pagingAndSorting,
		}).build()
		return await axios.get(url)
	}
}
export default new AcompanhamentoAtaApiClient()
